import { useApp } from '../context.js';
import { todayLocal } from '../lib/date.js';

export default function PlanDateModal() {
    const { create, currentProfile, haptic, planDateForm, planDateSearch, restaurants, savePlannedDate, setPlanDateForm, setPlanDateSearch, setShowPlanDateModal, showPlanDateModal, showToast } = useApp();
    // Picking one of our places (or Surprise Me) drops any address left over from a Google search
    const pickExisting = (r) => {
        setPlanDateForm({ ...planDateForm, restaurantId: r.id, restaurantName: r.name, placeAddress: r.address || '', placeCoordinates: r.coordinates || null });
        const g = document.getElementById('plan-date-restaurant-input');
        if (g) g.value = '';
    };
    if (!showPlanDateModal) return null;
    return (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center p-4 z-50" onClick={() => setShowPlanDateModal(false)}>
            <div className="bg-white apple-card rounded-3xl max-w-md w-full shadow-2xl max-h-[85vh] overflow-hidden flex flex-col" onClick={(e) => e.stopPropagation()}>
                <div className="bg-gradient-to-r from-pink-400 via-rose-400 to-red-400 px-6 py-4 flex items-center justify-between flex-shrink-0">
                    <h2 className="text-xl font-bold text-white">💕 Plan a Date</h2>
                    <button onClick={() => setShowPlanDateModal(false)} className="text-white/80 hover:text-white text-2xl font-light">×</button>
                </div>
                <div className="p-6 space-y-4 overflow-y-auto flex-1">
                    <div className="grid grid-cols-2 gap-3">
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">Date</label>
                            <input
                                type="date"
                                value={planDateForm.date}
                                min={todayLocal()}
                                onChange={(e) => setPlanDateForm({...planDateForm, date: e.target.value})}
                                className="w-full px-3 py-3 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-base"
                            />
                        </div>
                        <div>
                            <label className="block text-sm font-bold text-gray-700 mb-2">Time</label>
                            <input
                                type="time"
                                value={planDateForm.time}
                                onChange={(e) => setPlanDateForm({...planDateForm, time: e.target.value})}
                                className="w-full px-3 py-3 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-base"
                            />
                        </div>
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Restaurant</label>
                        <input
                            type="text"
                            value={planDateSearch}
                            onChange={(e) => setPlanDateSearch(e.target.value)}
                            placeholder="Search your restaurants..."
                            className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-base mb-2"
                        />
                        <div className="max-h-40 overflow-y-auto border-2 border-gray-200 rounded-xl">
                            {restaurants
                                .filter(r => !r.deletedAt)
                                .filter(r => !planDateSearch.trim() || r.name.toLowerCase().includes(planDateSearch.toLowerCase()))
                                .map(r => (
                                    <button
                                        key={r.id}
                                        onClick={() => {
                                            pickExisting(r);
                                            haptic('light');
                                        }}
                                        className={`w-full text-left px-3 py-2.5 border-b border-gray-100 last:border-b-0 transition-colors ${
                                            planDateForm.restaurantId === r.id
                                                ? 'bg-pink-50 text-rose-700 font-semibold'
                                                : 'hover:bg-gray-50 text-gray-700'
                                        }`}
                                    >
                                        <div className="flex items-center justify-between">
                                            <span className="text-sm">{r.name}</span>
                                            {planDateForm.restaurantId === r.id && <span className="text-rose-500 text-xs">✓</span>}
                                        </div>
                                    </button>
                                ))
                            }
                        </div>
                        <div className="mt-2 text-center text-xs text-gray-400">or search a new place</div>
                        <input
                            id="plan-date-restaurant-input"
                            type="text"
                            placeholder="Search for a restaurant..."
                            className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-base mt-2"
                        />
                    </div>
                    <div>
                        <label className="block text-sm font-bold text-gray-700 mb-2">Notes (optional)</label>
                        <textarea
                            value={planDateForm.notes}
                            onChange={(e) => setPlanDateForm({...planDateForm, notes: e.target.value})}
                            placeholder="Dress code? Special occasion? Something sweet..."
                            className="w-full px-3 py-2.5 border-2 border-gray-200 rounded-xl focus:outline-none transition-colors text-base resize-none"
                            rows="2"
                        />
                    </div>
                    <button
                        onClick={() => {
                            const active = restaurants.filter(r => !r.deletedAt);
                            if (active.length === 0) return;
                            const random = active[Math.floor(Math.random() * active.length)];
                            pickExisting(random);
                            haptic('medium');
                        }}
                        className="w-full bg-gradient-to-r from-purple-400 to-indigo-400 text-white px-3 py-2.5 rounded-xl font-semibold text-sm apple-button"
                    >
                        🎲 Surprise Me!
                    </button>
                </div>
                <div className="p-6 pt-3 border-t border-gray-100 flex gap-2 flex-shrink-0">
                    <button
                        onClick={() => {
                            setShowPlanDateModal(false);
                            setPlanDateForm({ restaurantId: null, restaurantName: '', date: '', time: '', notes: '' });
                            setPlanDateSearch('');
                        }}
                        className="flex-1 bg-gray-200 text-gray-700 px-4 py-3 rounded-xl font-semibold apple-button"
                    >
                        Cancel
                    </button>
                    <button
                        onClick={() => {
                            if (!planDateForm.restaurantName.trim() || !planDateForm.date || !planDateForm.time) {
                                showToast('Please fill in restaurant, date, and time', 'error');
                                return;
                            }
                            const dateTime = planDateForm.date + 'T' + planDateForm.time + ':00';
                            let dateRestaurantId = planDateForm.restaurantId;

                            // If new restaurant (not from existing list), add it
                            if (!dateRestaurantId) {
                                const name = planDateForm.restaurantName.trim();
                                const exists = restaurants.find(r =>
                                    !r.deletedAt && r.name.toLowerCase().trim() === name.toLowerCase()
                                );
                                if (exists) {
                                    dateRestaurantId = exists.id;
                                } else {
                                    const newId = Date.now();
                                    create({
                                        id: newId,
                                        name: name,
                                        address: planDateForm.placeAddress || null,
                                        coordinates: planDateForm.placeCoordinates || null,
                                        placeId: planDateForm.placeId || null,
                                        isFavorite: false,
                                        notes: '',
                                        photo: null,
                                        visits: [],
                                        rating: null,
                                        checks: [],
                                        dateAdded: new Date().toISOString()
                                    });
                                    dateRestaurantId = newId;
                                }
                            }

                            savePlannedDate({
                                restaurantId: dateRestaurantId,
                                restaurantName: planDateForm.restaurantName.trim(),
                                dateTime: dateTime,
                                notes: planDateForm.notes.trim(),
                                address: planDateForm.placeAddress || '',
                                coordinates: planDateForm.placeCoordinates || null,
                                plannedBy: currentProfile,
                                createdAt: Date.now()
                            });
                            setShowPlanDateModal(false);
                            setPlanDateForm({ restaurantId: null, restaurantName: '', date: '', time: '', notes: '' });
                            setPlanDateSearch('');
                        }}
                        disabled={!planDateForm.restaurantName.trim() || !planDateForm.date || !planDateForm.time}
                        className={`flex-1 px-4 py-3 rounded-xl font-semibold apple-button ${
                            planDateForm.restaurantName.trim() && planDateForm.date && planDateForm.time
                                ? 'bg-gradient-to-r from-pink-400 to-rose-500 text-white'
                                : 'bg-gray-300 text-gray-500 cursor-not-allowed'
                        }`}
                    >
                        💕 Plan Date
                    </button>
                </div>
            </div>
        </div>
    );
}
